import * as Yup from 'yup'
import { SituacaoDiagnosticoType } from '_metronic/helpers'

export const CIDSchema = Yup.object().shape({
  situacaoDiagnostico: Yup.object()
    .nullable()
    .required('Obrigatório selecionar a situação diagnóstica'),
  cid: Yup.object()
    .nullable()
    .when('situacaoDiagnostico', {
      is: (situacaoDiagnostico?: { value?: SituacaoDiagnosticoType }) =>
        situacaoDiagnostico?.value === SituacaoDiagnosticoType.Diagnosticado,
      then: (schema) => schema.required('Obrigatório selecionar um CID'),
    }),
})
